import i18n from "i18next";
import {initReactI18next} from "react-i18next";
import en from "./locales/en/translation.json";
import es from "./locales/es/translation.json";

// Function to get initial language from URL parameters or localStorage
const getInitialLanguage = () => {
    const url = new URL(window.location.href);
    const languageParam = url.searchParams.get("language");
    
    if (languageParam) {
        const lang = languageParam.toLowerCase();
        localStorage.setItem("lang", lang);
        return lang === "spanish" || lang === "es" ? "es" : "en";
    }
    
    return "en"; // default fallback
};

const detectionOptions = {
    caches: ['cookie'],
    cookieSameSite: 'strict',
    lookupQuerystring: 'lang', // default is lng
    lookupCookie: 'next-i18next',
    order: ['querystring', 'cookie', 'header'], // IMPORTANT
}

const resources = {
    en,
    es
}

const initialLanguage = getInitialLanguage();

i18n
.use(initReactI18next)
.init({
    resources,
    detection: detectionOptions,
    defaultNS: "common",
    fallbackLng: "en",
    lng: initialLanguage, // Set initial language
});